import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad";

// Connects to data-controller="signature-pad"
export default class extends Controller {
  static targets = ["canvas", "canvasRepresentante", "canvasRepresentante2"];

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget);
    this.signaturePadRepresentante = new SignaturePad(this.canvasRepresentanteTarget);
    this.signaturePadRepresentante2 = new SignaturePad(this.canvasRepresentante2Target);
    console.log(this.canvasTarget)
    console.log(this.canvasTarget.style.display)
    if (this.canvasTarget.style.display != 'none') {
      this.canvasTarget.style.display = 'block';
    }
    if (this.canvasRepresentanteTarget.style.display != 'none') {
      this.canvasRepresentanteTarget.style.display = 'block';
    }
    if (this.canvasRepresentante2Target.style.display != 'none') {
      this.canvasRepresentante2Target.style.display = 'block';
    }
  }

  clearPaciente(e) {
    e.preventDefault();
    this.signaturePad.clear();
  }

  clearRepresentante(e) {
    e.preventDefault();
    this.signaturePadRepresentante.clear();
  }

  clearRepresentante2(e) {
    e.preventDefault();
    this.signaturePadRepresentante2.clear();
  }

  savePaciente(e) {
    e.preventDefault();

    const signatureData = this.signaturePad.toDataURL();
    const hiddenField = document.getElementById('firma');

    hiddenField.value = signatureData;

    this.updateAcceptButtonState();
  }

  saveRepresentante(e) {
    e.preventDefault();

    const signatureData = this.signaturePadRepresentante.toDataURL();
    const hiddenField = document.getElementById('firma_representante');

    hiddenField.value = signatureData;

    this.updateAcceptButtonState();
  }

  saveRepresentante2(e) {
    e.preventDefault();

    const signatureData = this.signaturePadRepresentante2.toDataURL();
    const hiddenField = document.getElementById('firma_representante_2');

    hiddenField.value = signatureData;

    this.updateAcceptButtonState();
  }

  hasAnySignature() {
    const hiddenFieldPaciente = document.getElementById('firma');
    const hiddenFieldRepresentante = document.getElementById('firma_representante');
    const hiddenFieldRepresentante2 = document.getElementById('firma_representante_2');

    return (
      hiddenFieldPaciente.value.trim() !== "" ||
      hiddenFieldRepresentante.value.trim() !== "" ||
      hiddenFieldRepresentante2.value.trim() !== ""
    );
  }

  updateAcceptButtonState() {
    const acceptButton = document.querySelector('input[type="submit"]');
    acceptButton.disabled = !this.hasAnySignature();
  }
}
